/** Combined Invest hub: Syndicates, RUVs and Deal Invites. */
export const INVEST_HUB_PATH = '/invest';
/** Syndicated deals live at the hub root; RUVs get their own path. */
export const INVEST_HUB_SYNDICATES_PATH = INVEST_HUB_PATH;
export const INVEST_HUB_RUVS_PATH = `${INVEST_HUB_PATH}/ruvs`;
export const INVEST_HUB_DEAL_INVITES_PATH = `${INVEST_HUB_PATH}/deal-invites`;
